import AccountBalanceWallet from '@mui/icons-material/AccountBalanceWallet'
import CreditCard from '@mui/icons-material/CreditCard'
import FiberManualRecord from '@mui/icons-material/FiberManualRecord'
import Remove from '@mui/icons-material/Remove'
import { Menu, MenuItem } from '@mui/material'
import { STATUS_PAYMENT } from '../../../../constants'
import { IInvoice } from 'models/invoices.models'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import './styles.scss'

const ChangeCFDIStatusMenu = () => {
  const {
    activeInvoice,
    paymentStatusAnchor,
    onChangeCfdiPayStatus,
    updateState,
  } = useCFDIsContainerContext()

  const typedInvoice = activeInvoice as IInvoice

  return (
    <Menu
      id="changeStatusMenu"
      className="change-invoice-status-menu-component"
      anchorEl={paymentStatusAnchor}
      open={Boolean(paymentStatusAnchor)}
      keepMounted
      onClose={() =>
        updateState(draft => {
          draft.paymentStatusAnchor = null
        })
      }>
      {activeInvoice?.statusPayment?.value !== STATUS_PAYMENT.CHARGED && (
        <MenuItem
          className="status-container"
          onClick={e => {
            e.stopPropagation()
            onChangeCfdiPayStatus(typedInvoice, STATUS_PAYMENT.CHARGED)
          }}>
          <FiberManualRecord
            className="status-payment-icon charged"
            fontSize="small"
          />
          Cobrada
        </MenuItem>
      )}
      {activeInvoice?.statusPayment?.value !== STATUS_PAYMENT.PART_CHARGED && (
        <MenuItem
          className="status-container"
          onClick={e => {
            e.stopPropagation()
            onChangeCfdiPayStatus(typedInvoice, STATUS_PAYMENT.PART_CHARGED)
          }}>
          <AccountBalanceWallet
            className="status-payment-icon part-charged"
            fontSize="small"
          />
          Cobrada parcialmente
        </MenuItem>
      )}
      {activeInvoice?.movementType === 'E' &&
        activeInvoice?.statusPayment?.value !== STATUS_PAYMENT.PAID && (
          <MenuItem
            className="status-container"
            onClick={e => {
              e.stopPropagation()
              onChangeCfdiPayStatus(typedInvoice, STATUS_PAYMENT.PAID)
            }}>
            <FiberManualRecord
              className="status-payment-icon paid"
              fontSize="small"
            />
            Pagada
          </MenuItem>
        )}
      {activeInvoice?.movementType === 'E' &&
        activeInvoice?.statusPayment?.value !== STATUS_PAYMENT.PART_PAID && (
          <MenuItem
            className="status-container"
            onClick={e => {
              e.stopPropagation()
              onChangeCfdiPayStatus(typedInvoice, STATUS_PAYMENT.PART_PAID)
            }}>
            <CreditCard
              className="status-payment-icon part-paid"
              fontSize="small"
            />
            Pagada parcialmente
          </MenuItem>
        )}
      {activeInvoice?.statusPayment?.value &&
        activeInvoice?.statusPayment?.value !== STATUS_PAYMENT.PENDING && (
          <MenuItem
            className="status-container"
            onClick={e => {
              e.stopPropagation()
              onChangeCfdiPayStatus(typedInvoice, STATUS_PAYMENT.PENDING)
            }}>
            <Remove className="status-payment-icon" fontSize="small" />
            Pendiente
          </MenuItem>
        )}
    </Menu>
  )
}

export default ChangeCFDIStatusMenu
